export default __webpack_public_path__ + "static/3-96ba4bbc52b15dc9b7dec326cf748364.png";